import StandardCardGroupDisplay from '@components/StandardCardGroupDisplay'
import { OwnNominees } from '@kudos/http-client'
import { getUserDisplayName } from '@shared/userDisplay/UserNameDisplay'
import { T, useT } from '@transifex/react'

type PastNominationsProps = {
  ownNominees?: OwnNominees
  nominationId: string
}

const PastNominations: React.FC<PastNominationsProps> = ({ ownNominees, nominationId }) => {
  const t = useT()
  if (!ownNominees || ownNominees.total === 0) return null
  const memberName = getUserDisplayName(ownNominees?.members[0], t)

  const messages = (count: number) => {
    if (count === 1) return <T _str="You’ve already nominated {member}" member={memberName} />

    if (count === 2)
      return <T _str="You’ve already nominated {member} and 1 other" member={memberName} />

    return (
      <T
        _str="You’ve already nominated {member} and {count} others"
        member={memberName}
        count={ownNominees.total - 1}
      />
    )
  }

  return (
    <StandardCardGroupDisplay
      maxAvatars={3}
      componentKey={`nominationsOwnNominees-${nominationId}`}
      total={ownNominees.total}
      tenantMemberDisplayData={ownNominees?.members}
      text={messages(ownNominees.total)}
    />
  )
}

export default PastNominations
